// The v3 envelopes app-api answers in, in ONE place: every demo route that answers in one builds it here, an answer the
// way `AppBaseController::prepare` wraps it and a refusal the way `sendError` builds it.
import type { BaseAPIResponse } from '~/types/api';

/** One entry in a v3 `errors` list: `AppBaseController::errorEntry`, with the reason's own fields beside it. */
export type V3ErrorEntry = {
    status: string;
    code: string;
    message: string;
    reason?: string;
    [field: string]: string | undefined;
};

/** The v3 error envelope. */
export type V3ErrorBody = { api: 'v3'; errors: V3ErrorEntry[] };

/** An answer in the v3 envelope, with the resource's own `meta` when it publishes one. */
export function envelope<T, M = never>(data: T, meta?: M): BaseAPIResponse<T, M> {
    return { data, query_id: 'demo', api_version: 3, response_time_ms: 12, ...(meta === undefined ? {} : { meta }) };
}

/**
 * A refusal of the request to `path` (no leading slash), as app-api refuses it: one entry whose `code` names the route,
 * and a machine-readable `reason` and its fields where the refusal carries them.
 */
export function refusal(
    path: string,
    status: number,
    message: string,
    reason?: { reason: string } & Record<string, string>,
): V3ErrorBody {
    return {
        api: 'v3',
        errors: [{ status: String(status), code: `I:v3:${path.replaceAll('/', ':')}`, message, ...reason }],
    };
}
